<script setup lang="ts">
interface Props {
  options: Array<{ value: string; label: string }>
  modelValue?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  modelValue: () => [],
})

const emit = defineEmits<{
  'update:modelValue': [value: string[]]
}>()

const toggleOption = (value: string) => {
  const newValue = props.modelValue.includes(value)
    ? props.modelValue.filter((v) => v !== value)
    : [...props.modelValue, value]
  emit('update:modelValue', newValue)
}
</script>

<template>
  <div class="space-y-2">
    <div v-for="option in options" :key="option.value" class="flex items-center space-x-2">
      <input
        type="checkbox"
        :checked="modelValue.includes(option.value)"
        @change="toggleOption(option.value)"
        class="rounded border-gray-300 text-primary-500 focus:ring-primary-500"
      />
      <span class="text-sm text-gray-700">{{ option.label }}</span>
    </div>
  </div>
</template>
